export const GET_CLOUD_DOCUMENTS = "FUND@GET_CLOUD_DOCUMENTS";
export const GET_CLOUD_DOCUMENTS_INIT = "FUND@GET_CLOUD_DOCUMENTS_INIT";
export const GET_CLOUD_DOCUMENTS_SUCCESS = "FUND@GET_CLOUD_DOCUMENTS_SUCCESS";
export const GET_CLOUD_DOCUMENTS_FAILED = "FUND@GET_CLOUD_DOCUMENTS_FAILED";
